<template>
  <div>
    <b-popover :target="target" triggers="click blur" placement="bottom" title="" ref="popover">
      <div class="donatePopover">
        <b-form-group label="Back the artists you love!"
                      description="Minimum $2.00" :state="inputState">
          <b-form-input size="sm" class="amount" v-model="amount" :state="inputState" />
        </b-form-group>
        <b-button class="btn-rainbow" @click="showModal" :disabled="!sendEnabled">
          <img src="/static/icons/donate.svg">
          send
        </b-button>
        <font-awesome-icon icon="spinner" size="lg" spin v-if="working" />
      </div>
    </b-popover>
    <CreditCardLinked ref="ccLinked" />
    <b-modal id="credit-confirm-modal"
             ref="credit-confirm-modal"
             title="Confirm Transaction"
             @cancel="hideModal"
             @ok="send"
             centered>
      <div class="content">
        <p>
          ${{ amount | decimals }} will be charged to your credit card.
        </p>
      </div>
    </b-modal>
  </div>
</template>

<style scopend lang="scss">

  #credit-confirm-modal {
    font-family: AvenirLight,Muli,Helvetica,sans-serif !important;
    text-align: left !important;
  }

  .donatePopover {
    width: 15em;

    img {
      width: 1.2em;
      margin-right: 0.5em;
    }

    .amount {
      width: 5em;
      font-size: 0.8em;
    }
  }

</style>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

import askForCard from '@/utils/stripe'
import CreditCardLinked from '@/components/widgets/CreditCardLinked'

export default {
  name: 'Donate',
  components: {
    FontAwesomeIcon,
    CreditCardLinked
  },
  props: {
    target: String,
    artist: Object,
    live: Object
  },
  data () {
    return {
      working: false,
      amount: ''
    }
  },
  filters: {
    decimals (value) {
      let txt = value.trim()
      if (txt[0] === '$') txt = txt.substr(1).trim()
      return Number(txt).toFixed(2)
    }
  },
  computed: {
    numAmount () {
      let txt = this.amount.trim()
      if (txt.length && txt[0] === '$') txt = txt.substr(1).trim()
      return +txt
    },
    inputState () {
      if (this.amount === '') return
      let amount = this.numAmount
      if (amount < 2.00) return 'invalid'
      return 'valid'
    },
    sendEnabled () {
      return this.inputState === 'valid'
    }
  },
  methods: {
    showModal () {
      this.$refs['credit-confirm-modal'].show()
    },
    hideModal () {
      this.$refs['credit-confirm-modal'].hide()
      this.amount = ''
    },
    async send () {
      this.$refs['credit-confirm-modal'].hide()

      if (!this.sendEnabled) return
      this.working = true

      if (!this.$store.getters['profile/currentUser'].stripe_customer_id) {
        const dialog = askForCard(this.$store)

        try {
          await dialog.finish
          this.$refs.ccLinked.show()
        } catch (e) {
          console.log('can\'t capture cc', e)
          this.working = false
          return
        }
      }

      let donation

      try {
        donation = await this.$store.dispatch('profile/donate', {
          id: this.artist.id,
          liveId: this.live ? this.live.id : undefined,
          amount: this.numAmount
        })
      } catch (err) {
        let error = 'Error making donation'
        if (err.response && err.response.data && err.response.data.message) {
          error = err.response.data.message
        }
        this.$store.dispatch('flash/showMessage', {message: error, type: 'error'})
        this.$refs.popover.$emit('close')
        this.working = false
        this.amount = ''
        return
      }

      if (this.live && this.live.chat_type === 'fan2artist') {
        donation.fan = this.$store.getters['profile/currentUser']
        this.$store.dispatch('realtime/injectOwnMessage', {
          message: {
            type: 'donation',
            donation: donation
          },
          action: 'action'
        })
      }

      this.$store.dispatch('flash/showMessage', {message: 'Thanks for your support!'})
      this.$refs.popover.$emit('close')
      this.working = false
      this.amount = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/Donate.vue